import isNil from 'lodash/isNil';
import { z, ZodEnum } from 'zod';

import { normaliseString } from './textHelpers.ts';

export const LiteralSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export const isEnumValue = <
  T extends string,
  EnumSchema extends ZodEnum<Record<T, T>>,
>(
  value: string | null | undefined,
  schema: EnumSchema
): EnumSchema['_zod']['output'] | undefined => {
  // Get the list of enum values from the schema
  const enumValues = schema.options;

  // Create a map where the keys are the normalised enum values
  const normalisedEnumMap = enumValues.reduce(
    (acc, enumValue) => {
      const normalisedEnumValue = normaliseString(enumValue);
      acc[normalisedEnumValue] = enumValue;
      return acc;
    },
    {} as Record<string, T>
  );

  // Normalise the input value
  if (isNil(value)) return undefined;
  const normalisedValue = normaliseString(value);

  // Check if the normalised value exists in the enum map
  return normalisedEnumMap[normalisedValue] ?? undefined;
};
